import { render, staticRenderFns } from "./CoachAccordionSettings.vue?vue&type=template&id=0333f807&scoped=true&"
import script from "./CoachAccordionSettings.vue?vue&type=script&lang=ts&"
export * from "./CoachAccordionSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CoachAccordionSettings.vue?vue&type=style&index=0&id=0333f807&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0333f807",
  null
  
)

export default component.exports